module.exports = __webpack_public_path__ + "static/2.750dd581.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/work/cityatlas/img/2.png
// module id = 526
// module chunks = 278102253565233